import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import Layout from 'Components/Layout';
import Loading from 'Components/Loading';
import { loadQRCodes } from 'store/slices/personalSlice';
import QRList from 'Components/Personal/QRCode/QRList';
import CreateQRCodeModal from 'Components/Personal/QRCode/CreateQRCodeModal';

function QRCodes({
  loadQRCodes,
  qrCodes,
  cards
}) {
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  useEffect(() => {
    loadQRCodes().then(() => {
      setIsLoading(false);
    }).catch(error => {
      console.error('Error loading QR codes:', error);
      setIsLoading(false);
    });
  }, [loadQRCodes]);

  // Temporarily don't show the Public card
  const visibleQRCodes = (qrCodes || []).filter(item => {
    const label = (item.label || item.name || '').toLowerCase();
    const cardName = (item.cardName || item.cardname || '').toLowerCase();
    return !label.includes('public') && !cardName.includes('public');
  });

  return <Layout fluid={true}>
      <Helmet>
        <title>{t("My QR Codes")}</title>
      </Helmet>
      <div className="qrcodes-page-wrapper px-2 px-md-3 pt-0 pb-3">
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 pb-2 border-bottom gap-2">
          <div className="d-flex align-items-center gap-2">
            <h4 className="mb-0 fw-bold text-dark">{t("My QR Codes")}</h4>
            <span className="badge bg-light text-secondary border rounded-pill px-2 py-1 small">
              {visibleQRCodes?.length || 0}
            </span>
          </div>
          <Button color="primary" size="sm" className="px-3 py-1 fw-semibold shadow-sm text-nowrap" onClick={() => setShowCreateModal(true)}>
            {t("+ Create New QR Code")}
          </Button>
        </div>

        {isLoading ? (
          <Loading />
        ) : visibleQRCodes && visibleQRCodes.length > 0 ? (
          <QRList items={visibleQRCodes} />
        ) : (
          <div className="text-center py-4 border rounded bg-light my-2">
            <h6 className="text-muted mb-2">{t("You don't have any QR codes yet.")}</h6>
            <p className="text-muted mb-3 small">{t("Create a QR code to quickly share your contact card with others.")}</p>
            <Button color="primary" size="sm" onClick={() => setShowCreateModal(true)}>
              {t("+ Create Your First QR Code")}
            </Button>
          </div>
        )}

        <CreateQRCodeModal isOpen={showCreateModal} toggle={() => setShowCreateModal(false)} cards={cards} />
      </div>
    </Layout>;
}

const mapStateToProps = state => ({
  qrCodes: state.personal.qrCodes,
  cards: state.auth.currentUser?.profile?.cards || []
});

const mapDispatchToProps = {
  loadQRCodes
};
export default connect(mapStateToProps, mapDispatchToProps)(QRCodes);